import { FORM_TYPE, FormType } from '@/types/enums';
import { observer } from 'mobx-react-lite';
import NonRentalDateForm from '../../component/NonRentalDateForm';
import { useParams } from 'react-router-dom';
import { useStore } from '@/hooks/useStore';

export default observer(function NonRentalDate({ type }: { type: FormType }) {
    const isCreate = type === FORM_TYPE.Create;

    // hook
    const { id } = useParams();

    // store
    const { bikeStore: { bikeDetail } } = useStore();

    // get id
    const newId = isCreate ? bikeDetail?.id : id;

    return (
        <div className='bg-background-4'>
            <NonRentalDateForm
                isPage={true}
                bikeIds={newId ? [+newId] : []}
                type={type}
            />
        </div>
    );
});
